// Адаптеры платформы. Логика ядра ничего не знает про браузер, Electron и файловую систему: всё, что
// зависит от среды, приходит сюда через интерфейсы (§4.3 документа 09). Так одно ядро работает и в вебе,
// и на десктопе, а тесты подставляют свои реализации без подмены глобальных объектов.

import type { Bytes } from "./bytes.ts";

/** Часы. Отдельно от `Date.now`, потому что подпись запроса зависит от времени, а в тестах его двигают. */
export interface Clock {
  /** Миллисекунды Unix UTC. */
  now(): number;
}

/** Источник случайности: nonce подписи и ключи устройства. */
export interface RandomSource {
  bytes(length: number): Bytes;
}

/**
 * Хранилище секретов платформы: токен сессии, идентификатор устройства. В браузере — IndexedDB,
 * на десктопе — связка ключей ОС. В открытом виде (localStorage) токен не хранится (§3 задания Р-09).
 */
export interface SecretStore {
  get(key: string): Promise<string | undefined>;
  set(key: string, value: string): Promise<void>;
  delete(key: string): Promise<void>;
}

/** Часы системы. */
export const systemClock: Clock = {
  now: () => Date.now(),
};

/** Случайность платформы (WebCrypto есть и в браузере, и в Node). */
export const webCryptoRandom: RandomSource = {
  bytes(length: number): Bytes {
    return crypto.getRandomValues(new Uint8Array(length));
  },
};

/** Хранилище в памяти: годится для тестов и для короткоживущих процессов, но не для настоящей сессии. */
export class MemorySecretStore implements SecretStore {
  readonly #items = new Map<string, string>();

  get(key: string): Promise<string | undefined> {
    return Promise.resolve(this.#items.get(key));
  }

  set(key: string, value: string): Promise<void> {
    this.#items.set(key, value);
    return Promise.resolve();
  }

  delete(key: string): Promise<void> {
    this.#items.delete(key);
    return Promise.resolve();
  }
}
